import { useCallback } from 'react';

/**
 * Хук для автоматического выделения текста при фокусе на числовых полях
 * Удобно для полей с предзаполненными значениями (например, 0)
 */
export const useInputFocus = () => {
  const handleInputFocus = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    // Выделяем весь текст при фокусе
    e.target.select();
  }, []);

  return handleInputFocus;
}; 